import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import {phoneField} from '../../core/phonez'
import {linkFinder} from '../../core/links'
import LoaderButton from '../../core/components/LoaderButton'
import {loadAuthenticatedUser} from '../../user/actions'
import {UPDATE_USER_CMD_UPDATED, sendUpdateUserCmd, updateUpdateUserCmd, loadUserStream} from '../actions'
import {createValidator, UpdateUserCmd} from '../models'
import i18n from '../i18n'
import style from './UpdateUserModal.less'

function userCmdUpdate(user) {
    return {
        uid: user.uid || null,
        firstName: user.firstName || null,
        lastName: user.lastName || null,
        job: user.job || null,
        phone: user.phone || null,
    }
}

class UpdateUserModal extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, user} = this.props
        const update = userCmdUpdate(user)

        dispatch(updateUpdateUserCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user != this.props.user) {
            const {dispatch, user} = nextProps
            const update = userCmdUpdate(user)

            dispatch(updateUpdateUserCmd(update))
        }
    }

    _sendCmd(event) {
        const {dispatch, onHide, user, authenticated} = this.props

        return dispatch(sendUpdateUserCmd()).then(() => {
            return dispatch(loadUserStream())
        }).then(() => {
            if (user.uid == authenticated.uid) {
                return dispatch(loadAuthenticatedUser())
            }
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, user, authenticated, onHide, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.updateUser}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {user._links.find(linkFinder('UpdateUser')) && (
                        <div>
                            <form className='form-horizontal'>
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='firstName'
                                    label={requiredLabel(i18n.firstName)}
                                    {...form.firstName()} />
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='lastName'
                                    label={requiredLabel(i18n.lastName)}
                                    {...form.lastName()} />
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='job'
                                    label={i18n.job}
                                    {...form.job()} />
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='phone'
                                    label={i18n.phone}
                                    {...phoneField(form.phone())} />
                            </form>
                            <ButtonToolbar>
                                <LoaderButton
                                    bsStyle='primary'
                                    bsSize='large'
                                    className={cx({disabled: !form.isValid()})}
                                    onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                                    {i18n.save}
                                </LoaderButton>
                                <Button
                                    bsSize='large'
                                    onClick={onHide}>
                                    {i18n.cancel}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    )}
                    {user._links.find(linkFinder('DisableUser')) && (
                        <div className={style.disable}>
                            <a
                                href=''
                                onClick={(e) => onHide(e, 'DisableUser')}>
                                {i18n.disableUser}
                            </a>
                        </div>
                    )}
                    {user._links.find(linkFinder('DowngradeExecutiveToPatrimonyManager')) && (
                        <div className={style.disable}>
                            <a
                                href=''
                                onClick={(e) => onHide(e, 'DowngradeExecutiveToPatrimonyManager')}>
                                {i18n.downgradeExecutiveToPatrimonyManager + ' ...'}
                            </a>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

UpdateUserModal = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: UpdateUserCmd.schema,
    action: UPDATE_USER_CMD_UPDATED
})(UpdateUserModal)

UpdateUserModal = connect((state) => ({
    cmd: state.company.updateUserCmd,
    authenticated: state.user.authenticated
}))(UpdateUserModal)

export default UpdateUserModal


// WEBPACK FOOTER //
// ./lib/company/components/UpdateUserModal.js